<template>
  <div class="prize">
    <!-- 搜索条件 -->
    <el-form :inline="true" class="demo-form-inline">
      <el-form-item>
        <el-input v-model="params.id" placeholder="奖品id" style="width: 150px; margin-right: 20px"></el-input>
      </el-form-item>
      <el-form-item>
        <el-input v-model="params.name" placeholder="奖品名称" style="width: 200px; margin-right: 20px"></el-input>
      </el-form-item>
      <el-form-item>
        <el-input v-model="params.min_price" placeholder="最小价格" style="width: 150px; margin-right: 5px"></el-input>
        -
        <el-input v-model="params.max_price" placeholder="最大价格"
          style="width: 150px; margin-left: 5px; margin-right: 20px"></el-input>
      </el-form-item>
      <el-form-item>
        <el-select v-model="params.delivery_type" placeholder="发货方式">
          <el-option :value="1" label="手动发货"></el-option>
          <el-option :value="2" label="机器人发货"></el-option>
          <el-option :value="3" label="扎比特发货(人工手动)"></el-option>
          <el-option :value="4" label="扎比特发货(自动脚本)"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-select v-model="params.premium" placeholder="选择类型">
          <el-option :value="undefined" label="全部"></el-option>
          <el-option :value="1" label="正常"></el-option>
          <el-option :value="2" label="溢价"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-select v-model="params.goods_apply" placeholder="选择物品应用">
          <el-option :value="undefined" label="全部"></el-option>
          <el-option :value="1" label="未使用"></el-option>
          <el-option :value="2" label="普通盲盒"></el-option>
          <el-option :value="3" label="热血盲盒"></el-option>
          <el-option :value="4" label="全部使用"></el-option>
        </el-select>
      </el-form-item>
      <!-- <el-form-item>
        <el-select v-model="params.price_up_type">
          <el-option :value="undefined" label="全部更新类型"></el-option>
          <el-option :value="1" label="自动"></el-option>
          <el-option :value="2" label="手动"></el-option>
          <el-option :value="3" label="不更新"></el-option>
        </el-select>
      </el-form-item> -->
      <el-form-item>
        <el-button type="primary" @click="handleSearch">搜索</el-button>
      </el-form-item>
    </el-form>

    <!-- 操作按钮 -->
    <el-form :inline="true" class="demo-form-inline">
      <el-form-item>
        <el-button style="margin-right: 20px" size="small" type="primary" @click="handleAdd">添加奖品</el-button>
      </el-form-item>
      <!-- <el-form-item>
        <el-button
          style="margin-right: 20px"
          size="small"
          type="primary"
          @click="updateZBTPrice"
          >更新zbt价格</el-button
        >
      </el-form-item> -->
      <el-form-item>
        <el-button style="margin-right: 20px" size="small" type="primary" @click="exportPrize">导出未读奖品</el-button>
      </el-form-item>
      <!-- <el-form-item>
          <el-button
          style="margin-right: 20px"
          size="small"
          type="primary"
          @click="updatePrizePrice"
          >更新zbt->奖品价格</el-button
        >
      </el-form-item> -->
      <el-form-item>
        <el-button style="margin-right: 20px" size="small" type="primary" @click="updateIgPrice">更新IG价格</el-button>
      </el-form-item>
      <el-form-item>
        <el-button style="margin-right: 20px" size="small" type="primary" @click="updatePrizeIgPrice">更新ig->奖品价格
        </el-button>
      </el-form-item>
      <el-form-item>
        <el-button style="margin-right: 20px" size="small" type="primary" @click="handleExport">导出(IG价格为0的物品)
        </el-button>
      </el-form-item>
      <!-- <el-form-item>
        <el-switch
          v-model="updateFlag"
          :active-value="1"
          :inactive-value="0"
          active-text="全部更新"
          inactive-text="价格更到普通盲盒"
          @change="handleSwitch"
        >
        </el-switch>
      </el-form-item> -->
      <el-form-item>
        <span>价格最后更新时间：{{ prize_update_time ? prize_update_time : "暂无" }}</span>
      </el-form-item>
    </el-form>

    <div>
      <el-alert title="温馨提示" type="warning" description="扎比特发货(人工手动)是指用户提取后,管理员购买发货方式;扎比特发货(自动脚本)是指用户提取,脚本自动购买,无需后台发货"
        show-icon>
      </el-alert>
      <el-table :data="dataList" v-loading="loading">
        <el-table-column prop="id" label="奖品ID" width="100px">
          <template slot-scope="{ row }">
            <span :style="row.is_battle ? 'color:red;' : ''">{{ row.id }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="name" label="奖品名称"></el-table-column>
        <el-table-column prop="second_name" label="第二名称"></el-table-column>
        <el-table-column label="图片">
          <template slot-scope="{ row }">
            <img style="width:80px" class="table-image" :src="row.image" alt />
          </template>
        </el-table-column>
        <el-table-column prop="price" label="价格"></el-table-column>
        <el-table-column prop="mhb_price" label="对战价格"></el-table-column>
        <el-table-column prop="ig_prize" label="IG最新价格"></el-table-column>
        <!-- <el-table-column prop="zbt_prize" label="ZBT最新价格"></el-table-column>
        <el-table-column prop="category_id" label="所属分类">
          <template slot-scope="{ row }">{{
              getCategoryName(row.category_id)
          }}</template>
        </el-table-column> -->
        <el-table-column label="等级">
          <template slot-scope="{ row }">
            <span :style="`color: ${getRankColor(row.rank)};`">{{
                getRank(row.rank)
            }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="wear_degree" label="磨损度">
          <template slot-scope="{ row }">
            <span v-if="row.wear_degree === 0">崭新出厂</span>
            <span v-if="row.wear_degree === 1">略有磨损</span>
            <span v-if="row.wear_degree === 2">久经沙场</span>
            <span v-if="row.wear_degree === 3">破损不堪</span>
            <span v-if="row.wear_degree === 4">战痕累累</span>
            <span v-if="row.wear_degree === 5">无涂装</span>
          </template>
        </el-table-column>
        <el-table-column prop="sale_count" label="在售数量"></el-table-column>
        <el-table-column prop="goods_apply" label="物品应用">
          <template slot-scope="{ row }">
            <span v-if="row.goods_apply === 1">暂未使用</span>
            <span v-if="row.goods_apply === 2">普通盲盒</span>
            <span v-if="row.goods_apply === 3">热血盲盒</span>
            <span v-if="row.goods_apply === 4">全部使用</span>
          </template>
        </el-table-column>
        <el-table-column prop="darkgoldenrod" label="暗金">
          <template slot-scope="{ row }">
            <span v-if="row.darkgoldenrod === 1">普通</span>
            <span v-if="row.darkgoldenrod === 2">StatTrak™</span>
            <span v-if="row.darkgoldenrod === 3">★StatTrak™</span>
            <span v-if="row.darkgoldenrod === 4">★</span>
            <span v-if="row.darkgoldenrod === 5">纪念品</span>
          </template>
        </el-table-column>
        <el-table-column prop="delivery_type" label="发货方式">
          <template slot-scope="{ row }">
            <span v-if="row.delivery_type === 1">手动发货</span>
            <span v-if="row.delivery_type === 2">机器人发货</span>
            <span v-if="row.delivery_type === 3">扎比特发货(人工手动)</span>
            <span v-if="row.delivery_type === 4">扎比特发货(自动脚本)</span>
          </template>
        </el-table-column>
        <el-table-column prop="number" label="数量">
          <template slot-scope="{ row }">{{ row.number }}</template>
        </el-table-column>
        <el-table-column label="操作" width="240px">
          <template slot-scope="{ row }">
            <el-button type="primary" plain @click="handleEdit(row)">编辑</el-button>
            <el-button type="primary" plain @click="openDetailsDialog(row)">详情</el-button>
            <el-button type="danger" @click="handleDelete(row.id)">删除</el-button>
            <!-- <el-button
              type="primary"
              @click="handleChangeNumber(row.id, row.number)"
              >修改数量</el-button
            > -->
          </template>
        </el-table-column>
      </el-table>
      <el-pagination background :page-size="dataMeta.per_page || 15" :total="dataMeta.total || 0"
        :current-page="dataMeta.current_page" @current-change="handlePageChange"
        v-if="dataMeta && dataMeta.total > dataMeta.per_page"></el-pagination>
    </div>
    <el-dialog :visible.sync="visible" :title="isEdit ? '编辑奖品' : '添加奖品'" width="400px" destroy-on-close
      :close-on-click-modal="false">
      <el-form :model="formData" label-width="100px" :rules="rules" ref="form">
        <el-form-item prop="category_id" label="奖品分类">
          <el-select v-model="formData.category_id" placeholder="请选择奖品分类">
            <el-option v-for="item in categories" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="name" label="奖品名称">
          <el-input v-model="formData.name"></el-input>
        </el-form-item>
        <el-form-item prop="second_name" v-if="formData.category_id != 5" label="第二名称">
          <!-- <el-input v-model="formData.second_name"></el-input> -->
          <el-autocomplete class="inline-input" v-model="formData.second_name" :fetch-suggestions="querySearch"
            placeholder="请输入内容"></el-autocomplete>
        </el-form-item>
        <el-form-item prop="image" label="图片">
          <el-upload class="avatar-uploader" :action="action" :data="{ disk: imgType }" :show-file-list="false"
            :on-success="handleUploadSuccess" :before-upload="beforeImageUpload" :headers="headers" accept="image/*"
            name="file">
            <img class="avatar" v-if="formData.image" :src="formData.image" />
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
          <p>推荐尺寸256 * 192（4:3）</p>
        </el-form-item>
        <el-form-item prop="price" label="价格">
          <el-input v-model="formData.price"></el-input>
        </el-form-item>
        <el-form-item prop="mhb_price" label="对战价格">
          <el-input v-model="formData.mhb_price"></el-input>
        </el-form-item>
        <el-form-item prop="rank" label="等级">
          <el-select v-model="formData.rank">
            <el-option v-for="item in ranks" :key="item.level" :value="item.level" :label="item.text">
              <span :style="`color: ${item.color};`">{{ item.text }}</span>
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="wear_degree" v-if="formData.category_id != 5" label="磨损度">
          <el-select v-model="formData.wear_degree">
            <el-option :value="100" label="无"> </el-option>
            <el-option v-for="item in quality" :key="item.degree" :value="item.degree" :label="item.text">
              <span>{{ item.text }}</span>
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="darkgoldenrod" label="暗金" v-if="formData.shop_type != 3">
          <el-select v-model="formData.darkgoldenrod">
            <!-- 商城的暗金与奖品的暗金 值与文字不是对应的 -->
            <el-option :value="1" label="普通"> </el-option>
            <el-option :value="2" label="StatTrak™"> </el-option>
            <el-option :value="3" label="★StatTrak™"> </el-option>
            <!-- <el-option :value="4" label="★"> </el-option>
            <el-option :value="5" label="纪念品"> </el-option> -->
          </el-select>
        </el-form-item>
        <el-form-item prop="delivery_type" label="发货方式">
          <el-select v-model="formData.delivery_type">
            <el-option v-for="item in deliveryType" :key="item.value" :value="item.value" :label="item.text">
              <span>{{ item.text }}</span>
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="number" label="数量">
          <el-input v-model="formData.number" placeholder="奖品初始数量"></el-input>
        </el-form-item>
        <el-form-item>
          <AddIGGoods :prizeInfo="selectedPrize" @selectedData="getSelectedData" :buttonFlag="true"></AddIGGoods>
        </el-form-item>
        <el-form-item>
          <el-button size="small" @click="visible = false">取 消</el-button>
          <el-button size="small" type="primary" @click="submit" :loading="buttonLoading">确 定</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

    <!-- 弹窗 -->
    <!-- 详情弹窗 -->
    <DetailsDialog :visible="detailsVisible" v-model="dialogInfos" @close="detailsVisible = false"></DetailsDialog>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import http, { api, server, postData, getApiData, delData, patchData, getData, patchApiData } from '@/http'
import { getCookie } from '@/utils/cookie'
import saveFile from '@/utils/saveFile'
import ranks from '@/utils/ranks'
import DetailsDialog from '@/components/prize/DetailsDialog.vue.vue'
import AddIGGoods from '@/components/goods/AddIGGoods'//ig物品添加
import quality from '@/utils/quality'
import deliveryType from '@/utils/deliveryType'

export default {
  components: {
    DetailsDialog,
    AddIGGoods
  },
  data() {
    return {
      updateFlag: 0,//开关状态 0是关闭，1是打开
      detailsVisible: false,//详情弹窗显示标志
      dialogInfos: undefined,//弹窗传递数据
      ranks: ranks,//物品等级
      imgType: 'prize',//上传图片的种类 奖品
      quality,
      deliveryType,
      formData: {
        name: '',
        second_name: '',
        image: '',
        price: '',
        mhb_price: '',
        rank: '',
        category_id: undefined,
        wear_degree: '',
        number: '',
        darkgoldenrod: 1,
        delivery_type: 1,
      },
      selectedPrize: undefined,//选择的 IG 商品的信息
      rules: {
        category_id: [{ required: true, message: '请选择奖品种类' }],
        name: [{ required: true, message: '请输入奖品名称' }],
        // second_name: [{ required: true, message: '请输入奖品的第二名称' }],
        image: [{ required: true, message: '请添加奖品图片' }],
        price: [{ required: true, message: '请输入奖品的价格' }],
        mhb_price: [{ required: true, message: '请输入奖品的对战价格' }],
        rank: [{ required: true, message: '请选择奖品的等级' }],
        wear_degree: [{ required: true, message: '请选择奖品磨损度' }],
        darkgoldenrod: [{ required: true, message: '请选择奖品暗金' }],
        number: [{ required: true, message: '请输入奖品数量' }],
      },
      params: {
        page: 1,
        id: '',
        name: '',
        min_price: undefined,
        max_price: undefined,
        delivery_type: undefined,
        premium: undefined,
        goods_apply: undefined,//物品应用
        price_up_type: undefined
      },
      editInfo: undefined,
      loading: false,
      visible: false,
      buttonLoading: false,
      isEdit: false,
      dataList: undefined,
      dataMeta: {},
      prize_update_time: undefined,//价格最后更新时间
    }
  },
  computed: {
    ...mapState({
      categories: state => state.data.categories
    }),
    headers() {
      return {
        Authorization: 'Bearer ' + getCookie('access_token')
      }
    },
    action() {
      return `${server}file`
    }
  },
  watch: {
    visible(val) {
      if (val) {
        if (this.editInfo) {
          const {
            name,
            second_name,
            darkgoldenrod,
            delivery_type,
            image,
            price,
            mhb_price,
            category_id,
            wear_degree,
            rank,
            number
          } = this.editInfo
          this.formData = {
            name,
            second_name,
            darkgoldenrod,
            delivery_type,
            image,
            price,
            mhb_price,
            wear_degree,
            category_id,
            rank,
            number
          }
        }
      } else {
        this.formData = {
          name: '',
          second_name: '',
          darkgoldenrod: 1,
          delivery_type: 3,
          image: '',
          price: '',
          mhb_price: '',
          rank: '',
          wear_degree: '',
          category_id: parseInt(sessionStorage.getItem('categoryId')) || undefined,
          number: ''
        }
      }
    }
  },
  methods: {
    ...mapActions(['getCategories']),
    updateZBTPrice() {
      //更新zbt价格
      getApiData('update_zbt_prize').then(res => {
        this.$message.success('更新成功')
        this.getData()
      })
    },
    exportPrize() {
      //导出未读奖品
      window.open(`${api}prize_export`)
    },
    updatePrizePrice() {
      //更新zbt->奖品价格
      getApiData('update_prize_price').then(res => {
        this.$message.success('更新成功')
        this.getData()
      })
    },
    updateIgPrice() {
      //更新IG价格
      this.$prompt('请输入密码', '确认更新？', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputPattern: /lijiulong123/,
        inputErrorMessage: '密码不正确'
      }).then(({ value }) => {
        getApiData('update_ig_prize').then(res => {
          this.$message.success('更新成功')
          this.getData()
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        })
      })
    },
    updatePrizeIgPrice() {
      //更新ig->奖品价格
      this.$prompt('请输入密码', '确认更新？', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputPattern: /lijiulong123/,
        inputErrorMessage: '密码不正确'
      }).then(({ value }) => {
        getApiData('prize_ig_price').then(res => {
          this.$message.success('更新成功')
          this.getData()
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        })
      })
    },
    handleExport() {
      //导出
      http
        .post(
          server + 'prize/export',
          { ...this.params, page: undefined },
          {
            responseType: 'arraybuffer'
          }
        )
        .then(res => {
          saveFile(res, {
            type:
              'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            name: '提取订单记录.xlsx'
          })
        })
    },
    getSwitchStatus() {
      //获取关闭/打开更新开关状态
      let params = { key: '' }
      getApiData('system_config_enable', params).then(res => {
        if (res) {
          res.enable ? this.updateFlag = 1 : this.updateFlag = 0
        }
      }).finally(() => {
      })
    },
    handleSwitch() {
      //关闭/打开更新开关状态
      let params = {
        key: '',
        val: this.updateFlag
      }
      patchApiData('system_config_enable', params).then(res => {
        this.$message.success('操作成功！')
        this.getSwitchStatus()//刷新
      })
    },
    getRank(rank) {
      for (let item of this.ranks) {
        if (item.level === rank) {
          return item.text
        }
      }
    },
    getRankColor(rank) {
      for (let item of this.ranks) {
        if (item.level === rank) {
          return item.color
        }
      }
    },
    getCategoryName(id) {
      if (this.categories) {
        for (let item of this.categories) {
          if (item.id === id) {
            return item.name
          }
        }
      } else {
        return ''
      }
    },
    beforeImageUpload(file) {
      if (file.size > 2 * 1024 * 1024) {
        this.$message.error('图片尺寸过大，请选择2M大小以下的图片上传')
        return false
      }
    },
    handleUploadSuccess(res) {
      if (res.path) {
        this.formData.image = res.path
      } else {
        this.$message.error('上传失败')
      }
      this.$refs['form'].validateField('image')
    },
    getData() {
      this.loading = true
      getData(`prize`, this.params)
        .then(res => {
          this.dataList = res.data
          this.dataMeta = res
          this.prize_update_time = res.prize_update_time
        })
        .finally(() => {
          this.loading = false
        })
    },
    handleAdd() {
      this.isEdit = false
      this.editInfo = undefined
      this.visible = true
    },
    handleEdit(row) {
      this.isEdit = true
      this.editInfo = row
      this.visible = true
    },
    handlePageChange(page) {
      this.params.page = page
      this.getData()
    },
    // handleChangeNumber(id, number) {
    //   this.$prompt('', '修改奖品数量', {
    //     confirmButtonText: '确定',
    //     cancelButtonText: '取消',
    //     //inputPlaceholder: '正值增加，负值减少',
    //     customClass: 'change-prize-number',
    //     closeOnClickModal: false,
    //     inputPattern: /^(\-?)\d+(\.\d+)?$/,
    //     inputErrorMessage: '请输入数字'
    //   }).then(({ value }) => {
    //     if (parseInt(number) + parseInt(value) < 0) {
    //       this.$message.error('奖品数量不能为负')
    //       return
    //     }
    //     patchData(`prize/${id}`, {
    //       number: value
    //     }).then(res => {
    //       this.$message.success('修改成功')
    //       this.getData()
    //     })
    //   })
    // },
    handleSearch() {
      this.params.page = 1
      this.getData()
    },
    handleDelete(id) {
      this.$confirm('确定要删除吗？', {
        type: 'warning'
      }).then(res => {
        delData(`prize/${id}`).then(res => {
          this.$message.success('删除成功')
          this.getData()
        })
      })
    },
    openDetailsDialog(rowInfo) {
      //打开奖品详情弹窗
      this.detailsVisible = true
      this.dialogInfos = JSON.parse(JSON.stringify(rowInfo))
    },
    submit() {
      this.$refs['form'].validate(valid => {
        if (valid) {
          this.buttonLoading = true
          sessionStorage.setItem("categoryId", this.formData.category_id)//暂存奖品的分类
          if (!this.editInfo) {
            postData('prize', {
              ...this.formData
            })
              .then(res => {
                this.buttonLoading = false
                this.visible = false
                this.$message.success('添加成功')
                this.getData()
              })
              .finally(() => {
                this.buttonLoading = false
              })
          } else {
            patchData(`prize/${this.editInfo.id}`, {
              ...this.formData
            })
              .then(res => {
                this.buttonLoading = false
                this.visible = false
                this.$message.success('编辑成功')
                this.getData()
              })
              .finally(() => {
                this.buttonLoading = false
              })
          }
        }
      })
    },
    //获取到IG物品后的反参数据
    getSelectedData(data) {
      //赋值选择的物品信息
      // cago
      this.formData.category_id = 1//csgo物品
      this.formData.name = data.native_name//不带磨损度的名称
      this.formData.second_name = data.second_name//第二名称
      this.formData.image = data.image//图片
      this.formData.price = data.price//价格
      this.formData.price = data.price//价格
      this.formData.market_hash_name = data.market_hash_name;//ig或zbt要多传一个字段

      // 下面注释掉的属性因为字段不匹配导致的，需要添加人员手动去选择
      // this.formData.rank = data.rarity_name_status//等级对应的值
      // this.formData.wear_degree = data.appearance//磨损度对应的值
      // this.formData.number = data.number//数量
    },
    querySearch(queryString, cb) {
      //第二名称，下拉选择
      let restaurants = []
      for (let i = 0; i < quality.length; i++) {
        let obj = {
          "value": quality[i].text
        }
        restaurants.push(obj)
      }
      cb(restaurants);
    },
  },
  created() {
    this.getData()
    !this.categories && this.getCategories()
    // this.getSwitchStatus()
  }
}
</script>

<style lang="less" scoped>
.avatar-uploader {
  .avatar {
    width: 128px;
    height: 96px;
  }

  .avatar-uploader-icon {
    width: 128px;
    height: 96px;
    line-height: 96px;
  }
}
</style>
